<template>
  <div>
    <el-dialog
      title="Danh sách phòng"
      :visible.sync="dialogRoomVisible"
      :close-on-click-modal="false"
      width="85%"
      @closed="onCloseRoomDialog"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <hr />
            <div class="das-form-group">
              <div v-loading="roomTableLoading" style="height: 300px">
                <GridVx
                  ref="roomTable"
                  :columns="roomColumns"
                  :rows="roomRows"
                  :auto-size-cell="true"
                  dom-layout="scroll"
                  class="agGrid"
                  @selectionChanged="onSelectedRoom"
                />
              </div>
              <div class="checkin-group">
                <span class="checkin"
                  >Số phòng đã checkin: {{ checkinRooms }}</span
                >
                <span class="uncheckin"
                  >Số phòng chưa checkin: {{ uncheckinRooms }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <!-- <div class="button-containers-outline"> -->

          <button
            class="btn primary small outline"
            :disabled="
              selectedRoom === null ||
              selectedRoom?.status === '3' ||
              selectedRoom?.status === '2'
            "
            @click="openCancelRoomDialog"
          >
            Hủy đặt phòng
          </button>
          <!-- <button
            class="btn primary small outline"
            :disabled="selectedRoom === null || selectedRoom?.status !== '2'"
            @click="openCancelCheckinRoom"
          >
            Hủy check-in
          </button> -->
          <button
            class="btn primary small outline"
            :disabled="
              selectedRoom === null ||
              selectedRoom?.room_id === null ||
              selectedRoom?.room_id === 0
            "
            @click="lockRooms"
          >
            Khóa phòng
          </button>
          <!-- </div> -->
          <!-- <div class="button-containers-primary"> -->
          <button
            class="btn primary small"
            :disabled="
              selectedRoom === null ||
              selectedRoom?.is_master ||
              selectedRoom.status === '3'
            "
            @click="setMasterRoom"
          >
            Đặt master
          </button>
          <button
            class="btn primary small"
            :disabled="selectedRoom === null || selectedRoom?.status !== '1'"
            @click="checkinRoom"
          >
            Check-in
          </button>
          <button
            class="btn primary small"
            :disabled="canCheckinAll"
            @click="checkinAllRooms"
          >
            Check-in toàn bộ
          </button>
          <button
            class="btn primary small outline"
            :disabled="selectedRoom?.status !== '2'"
            @click="checkoutRoom"
          >
            Checkout
          </button>
          <button
            class="btn primary small outline"
            :disabled="canCheckoutAll"
            @click="checkoutAllRoom"
          >
            Checkout toàn bộ
          </button>
          <!-- <button
            class="btn primary small"
            :disabled="selectedRoom === null || selectedRoom?.status !== '1'"
            @click="checkinRoom"
          >
            Check-out
          </button>
          <button
            class="btn primary small"
            @click="checkinAllRooms"
          >
            Check-out toàn bộ
          </button> -->

          <button
            class="btn primary small"
            :disabled="selectedRoom === null"
            @click="viewUpdateRoomDetail"
          >
            Sửa/Xem chi tiết
          </button>
          <!-- </div> -->
        </div>
        <div class="button-containers close-btn">
          <button class="btn primary small outline" @click="onCloseRoomDialog">
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>

    <!--Cancel Room Dialog -->
    <el-dialog
      title="Hủy đặt phòng"
      :visible.sync="dialogCancelRoomVisible"
      :close-on-click-modal="false"
      width="720px"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <InfoList
                :columns="4"
                :column-breakpoint-options="{
                  sm: 1,
                  md: 4
                }"
              >
                <InfoListLabel>Số dư</InfoListLabel>
                <InfoListValue>{{ roomBalance }}</InfoListValue>
              </InfoList>
              <div class="das-form-row">
                <div class="das-form-col w-50">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.reason') }}
                    </div>
                    <validation-observer ref="cancelRoomFormValidator">
                      <validation-provider
                        rules="required"
                        :name="$t('field.reason')"
                      >
                        <select-with-search-table
                          style="width: 100%"
                          :rows="cancelReasonList"
                          :columns="cancelReasonColumns"
                          index-field="id"
                          :dropdown-width="400"
                          :selected-index-field-value="cancelRoomExplaination"
                          :value="cancelRoomExplaination"
                          @selectionChanged="onSelectRowCancelReason"
                        >
                          <template
                            v-slot:value="{ selectedValue: selectedReasonData }"
                          >
                            {{ selectedReasonData?.desc }}
                          </template>
                        </select-with-search-table>
                      </validation-provider>
                    </validation-observer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="fnConfirmCancelRoom">
            Xác nhận
          </button>
          <button
            class="btn primary small outline"
            @click="dialogCancelRoomVisible = false"
          >
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>

    <BookingRoomDetailDialog
      v-model="dialogBookingRoomDetailVisible"
      :data="selectedRoom"
      :is-disable="selectedRoom?.status !== '1'"
      :is-call-api="true"
      @onUpdateBookingRoom="onUpdateBookingRoom"
    />

    <IssueCardDialog v-model="dialogIssueCardVisible" :data="selectedRoom" />
  </div>
</template>

<script>
/* eslint-disable */
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'
import InfoList from '@/components/info-list/InfoList'
import { CellRenderCheckboxReadonly } from '@/utils/groupCellRenders'

import {
  getRoomListByGroupIdApi,
  cancelRoomApi,
  cancelCheckinApi,
  setMasterRoomApi,
  checkinApi,
  getRoomBalanceApi
} from '@/api/booking_service/bookingGroup'
import BookingRoomDetailDialog from '@/views/mci/group/components/BookingRoomDetailDialog.vue'
import IssueCardDialog from '@/views/mci/reception/components/IssueCardDialog.vue'
import {
  cardRoomCheckoutApi,
  checkoutCustomer
} from '@/api/cashier_service/postTransaction'
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
// import Multiselect from 'vue-multiselect'
export default {
  components: {
    InfoList,
    InfoListLabel,
    InfoListValue,
    BookingRoomDetailDialog,
    IssueCardDialog,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly
    // SingleCalendar,
    // Multiselect
    // IssueCardDialog
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectedData: {
      type: Object,
      default: () => {}
    },
    cancelReasonList: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      dialogIssueCardVisible: false,
      cancelRoomExplaination: null,
      // cancelReasonList: [],
      cancelReasonColumns: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'reason',
          tooltipField: 'reason',
          minWidth: 100
        }
      ],

      selectedRoom: null,
      roomBalance: null,

      dialogRoomVisible: false,
      dialogCancelRoomVisible: false,
      dialogBookingRoomDetailVisible: false,
      dialogIssueCardVisible: false,

      roomColumns: [
        {
          headerName: 'Mã đặt phòng',
          field: 'room_booking_code',
          headerTooltip: 'Mã đặt phòng',
          tooltipField: 'room_booking_code',
          minWidth: 100,
          maxWidth: 130
          // width: 50
        },
        // {
        //   headerName: 'Mã xác nhận',
        //   field: 'confirm_code',
        //   headerTooltip: 'Mã xác nhận',
        //   tooltipField: 'confirm_code',
        //   minWidth: 100,
        //   maxWidth: 130
        // },
        {
          headerName: 'Tên khách',
          field: 'first_name',
          cellRenderer: params => {
            return params.data.last_name + ' ' + params.data.first_name
          },
          tooltipValueGetter: params => {
            return params.data.last_name + ' ' + params.data.first_name
          },
          minWidth: 100
        },
        {
          headerName: 'Số phòng',
          field: 'room_num',
          tooltipField: 'room_num',
          minWidth: 100
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_type_code',
          tooltipField: 'room_type_code',
          minWidth: 100
        },
        {
          headerName: 'Phòng master',
          field: 'is_master',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center',
          minWidth: 100
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          cellRenderer: params => {
            var val
            switch (params.value) {
              case '1':
                val = 'Đặt phòng'
                break
              case '2':
                val = 'Đang ở'
                break
              case '3':
                val = 'Hủy'
                break
              case '4':
                val = 'Checkout'
                break
              default:
                break
            }
            return val
          },
          tooltipValueGetter: params => {
            var val
            switch (params.value) {
              case '1':
                val = 'Đặt phòng'
                break
              case '2':
                val = 'Đang ở'
                break
              case '3':
                val = 'Hủy'
                break
              case '4':
                val = 'Checkout'
                break
              default:
                break
            }
            return val
          },
          minWidth: 100
        },
        {
          headerName: ' Ngày đến',
          field: 'arrive_date',
          cellRenderer: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          },
          tooltipValueGetter: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          },
          minWidth: 100
        },
        {
          headerName: 'Ngày đi',
          field: 'depart_date',
          cellRenderer: params => {
            return params.value
          },
          tooltipValueGetter: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          },
          minWidth: 100
        },
        {
          headerName: 'Số lượng khách',
          field: 'num_of_guest',
          headerTooltip: 'Số lượng khách',
          tooltipField: 'num_of_guest',
          minWidth: 100
        }
        // {
        //   headerName: 'Công ty, đại lý du lịch',
        //   field: 'agent_name',
        //   headerTooltip: 'Công ty, đại lý du lịch',
        //   tooltipField: 'agent_name',
        //   minWidth: 200
        // }
      ],
      roomRows: [],
      // checkinRooms: 0,
      // uncheckinRooms: 0,
      canCheckinAll: false,
      canCheckoutAll: false,

      roomTableLoading: false,

      groupMasterData: {
        no: null,
        id: null,
        name: null,
        note: null,
        status: null,
        create_date: null,
        create_user_id: null,
        external_id: null,
        booking_code: null,
        confirm_code: null,
        first_arrival_date: null,
        last_departure_date: null,
        agent_id: null,
        agent_name: null,
        user_create: null,
        status_code: null
      }
    }
  },
  computed: {
    checkinRooms() {
      return this.roomRows.filter(item => {
        return item.status === '2'
      }).length
    },
    uncheckinRooms() {
      return this.roomRows.filter(item => {
        return item.status === '1'
      }).length
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        this.dialogRoomVisible = this.dialogVisible
        if (val) {
          this.fnGetRoomList()
        }
      }
    },
    selectedData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.groupMasterData = this.selectedData
        }
      }
    },
    roomRows: {
      immediate: true,
      deep: true,
      handler(val) {
        this.canCheckinAll =
          val.filter(item => item.status === '1' && item.room_id).length === 0
            ? true
            : false

        this.canCheckoutAll =
          val.filter(item => item.status === '2' && item.room_id).length === 0
            ? true
            : false
      }
    }
  },
  methods: {
    async checkoutRoom() {
      await checkoutCustomer({
        ids: [this.selectedRoom.room_booking_id]
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Checkout thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + (error.response?.data?.message ?? 'default')
            )
          })
        })
      await cardRoomCheckoutApi()
      await this.fnGetRoomList()
    },
    async checkoutAllRoom() {
      await checkoutCustomer({
        ids: this.roomRows
          .filter(item => item.status === '2' && item.room_num)
          .map(item => item.room_booking_id)
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Checkout thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + (error.response?.data?.message ?? 'default')
            )
          })
        })
      await cardRoomCheckoutApi()
      await this.fnGetRoomList()
    },
    // DATA
    async fnGetRoomList() {
      this.roomTableLoading = true
      getRoomListByGroupIdApi({ bookingGroupId: this.selectedData.id })
        .then(res => {
          this.roomRows = res.data
          // this.roomRows = [{ no: 1, code: 'hehe' }]
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.roomTableLoading = false
        })
    },

    openCancelRoomDialog() {
      this.fnGetRoomBalance()
      this.dialogCancelRoomVisible = true
    },
    onSelectRowCancelReason(val) {
      // console.log(val)
      this.cancelRoomExplaination = val.id
    },

    onSelectedRoom(selectRoom) {
      if (!selectRoom.length) {
        this.selectedRoom = null
      } else {
        this.selectedRoom = selectRoom[0]
      }
    },

    async fnGetRoomBalance() {
      await getRoomBalanceApi(this.selectedRoom.room_booking_code)
        .then(res => {
          this.roomBalance = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetRoomList()
        })
    },

    async fnConfirmCancelRoom() {
      // call api
      // alert('cancel room!!')
      if (
        (await this.$vxForm.isValid(this.$refs.cancelRoomFormValidator)) ===
        false
      ) {
        return
      }
      var params = {
        id: this.selectedRoom.room_booking_id,
        cancel_reason: this.cancelRoomExplaination
      }
      await cancelRoomApi(params)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Hủy phòng thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetRoomList()
        })
      this.cancelRoomExplaination = null
      this.dialogCancelRoomVisible = false
    },

    async openCancelCheckinRoom() {
      // call api
      // alert('Huy checkin thanh cong')
      await cancelCheckinApi({ id: this.selectedRoom.room_booking_id })
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Hủy checkin thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetRoomList()
        })
    },
    async setMasterRoom() {
      // alert('Dat phong master thanh cong')
      var params = {
        isMaster: true,
        bookingId: this.selectedRoom.room_booking_id
      }
      await setMasterRoomApi(params)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Đặt phòng master thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetRoomList()
        })
    },
    async checkinRoom() {
      // alert('Check in room id: ' + this.selectedRoom.no)
      await checkinApi([this.selectedRoom.room_booking_id])
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Checkin thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetRoomList()
        })
    },
    async checkinAllRooms() {
      // alert('Check in toàn bộ phòng thành công ')

      await checkinApi(
        this.roomRows
          .filter(item => item?.status === '1')
          .map(item => item.room_booking_id)
      )
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Checkin toàn bộ thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetRoomList()
        })
    },
    lockRooms() {
      // alert('Khóa phòng phòng ' + this.selectedRoom.room_num + ' thành công ')
      this.selectedRoom = Object.assign(
        {},
        {
          ...this.selectedRoom,
          sub_booking_group_id: this.selectedRoom.room_booking_id
        }
      )
      this.dialogIssueCardVisible = true
    },
    viewUpdateRoomDetail() {
      // alert('redirect sang trang chưa làm!!')
      this.dialogBookingRoomDetailVisible = true
    },
    onUpdateBookingRoom() {
      this.dialogBookingRoomDetailVisible = false
      this.fnGetRoomList()
    },

    // DIALOG
    onCloseRoomDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.w-50 {
  width: 50%;
}
.w-33 {
  width: 33%;
}
.w-25 {
  width: 25%;
}
.mr-2 {
  margin: 0 10px 0 0;
}
.close-btn {
  padding-top: 10px;
}
.checkin-group {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0 0;
}
.checkin {
  padding-top: 10px;
}
.button-containers-seperate {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 0 20px;
}
.button-containers-outline,
.button-containers-primary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}
</style>
